export default "__VITE_ASSET__iqX2dYlO__"